exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/** @format */\r\n\r\n.blinking {\r\n  display: inline-block;\r\n  margin-right: 15px;\r\n}\r\n", "", {"version":3,"sources":["C:/__w/1/s/src/components/shared/C:/__w/1/s/src/components/shared/FlashMessage.css"],"names":[],"mappings":"AAAA,cAAa;;AAEb;EACE,sBAAqB;EACrB,mBAAkB;CACpB","file":"FlashMessage.css","sourcesContent":["/** @format */\r\n\r\n.blinking {\r\n  display: inline-block;\r\n  margin-right: 15px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
